var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FilterSingleChip',{attrs:{"icon":"bookmark","is-text":_vm.isText,"label":_vm.$t('search-filters.action-filters.followed'),"items":_vm.items,"value":_vm.value && _vm.value.length ? _vm.value[0] : null},on:{"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }